export default {
  totalProfileBalance: 'AUM sum',
  userIraCount: 'IRA accounts number',
  totalOrderFeeAmount: 'Transaction fees paid',
  totalCustodyFeeAmount: 'Annual/custody fees paid',
  withdrawalFeesPaid: 'Withdrawal fees paid',
};
